<template>
    <div class="baseBody baseBody-content">
        <ScaleBox>
            <div class="main-wraper relative">
				<div style="width: 50%;height:620px;position: absolute;left:25%;top:0;">
					<!-- <BlockBox height="620" :hasTitle="false">
					    <template #content>
							<div style="padding-top: 5px;position: relative;">
								2222
								
							</div>
					    </template>
					</BlockBox> -->
					
				</div>

                <div class="custBodybg"></div>
                <div class="dateWeek">
                    <DynamicDate></DynamicDate>
                </div>
                <div class="fullBox">
                    <ScreenfullBox></ScreenfullBox>
                </div>
                <div class="baseTitleContent ">
                    <div class="baseTitleMid" style="width:759px;">
                        <div class="top" style="width:100%;">
                            <div class="topLine" style="width:100%;">
                                <div class="title text-center  text-white text-bold"  :style="'font-size:'+(siteName.length>11?30:32)+'px;'">{{siteName}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="position: fixed;width:100%;left:0;top:0;z-index:999;pointer-events:none;">
                    <div class="flex align-center justify-between">
                        <div>
                            <div class="baseTitleLeft"></div>
                        </div>
                        <div>
                            <div class="baseTitleRight"></div>
                        </div>
                    </div>
                </div>
                <div style="width:25% ;position: fixed;top: 60px;left:0;z-index: 999;">
                    <LeftContent></LeftContent>
                </div>
                <div style="width:50% ;position: fixed;top: 60px;left:25%;z-index: 999;">
                    <MidContent ref="midBlock"></MidContent>
                </div>
                <div style="width:25% ;position: fixed;top: 60px;right:0;z-index: 999;">
                    <RightContent></RightContent>
                </div>
            </div>
        </ScaleBox>
    </div>
</template>

<script>

    import DynamicDate from "../components/dynamicDate/index.vue";
    import ScreenfullBox from "../components/screenfull/index.vue";
    import ScaleBox from "../components/sacleBox/index.vue";
    import LeftContent from './components/fjzx/leftContent.vue'
    import RightContent from './components/fjzx/rightContent.vue'
    import MidContent from './components/fjzx/midContent.vue'
	// import BlockBox from '@/views/components/blockBox'
   
    import {
        // fjCenterData,
        //  fjSiteDataTrack
    } from "@/api/api";
    export default {
        components: {
            LeftContent,
            RightContent,
            ScaleBox,
            DynamicDate,
            ScreenfullBox,
            MidContent,
			// BlockBox
        },

        data() {
            return {
                map: null,
                lineList: [],
                postionList: [],
                runMakerList: [],
                dialogVisible: false,
                midData: null,
                siteId: '16',
                siteObj: {},
                // dataLineJson: require('@/assets/data-line-in.json'),
                loca: null,
                siteName:'',
                routeList:[],
				markerTcIdIndex:null,
				satelliteLayer:null,
				roadNetLayer:null,
				mpList:[
					{id:'mr',name:'mr',icon:require('@/assets/img/mr.png')},
					{id:'dark',name:'dark',icon:require('@/assets/img/dark.png')},
					{id:'wx',name:'wx',icon:require('@/assets/img/wx.png')}
				],
				mpListIndex:1,
				timer: null,
				 
            }
        },
        mounted() {
            this.siteId=this.$route.query.siteId || '16'
            this.siteName=this.$route.query.name || '腾冲市红十字会'
   //          this.changeData();
			// this.timer = setInterval(() => {
			//   this.changeData();
			// }, 60000); // 60秒 = 60000毫秒


        },
		beforeDestroy() {
		    // 组件销毁前清除定时器，避免内存泄漏
		    if (this.timer) {
		      clearInterval(this.timer);
		    }
		  },

        methods: {

            // changeData() {
            //     let _self = this
            //     fjCenterData({
            //         siteId: _self.siteId
            //     }).then(res => {
            //         _self.$refs.midBlock.getData(res.data)
            //         _self.siteObj = res.data.site
            //         fjSiteDataTrack({siteId: _self.siteId}).then(e=>{
            //             if(e.data.list && e.data.list.length>0){
            //               _self.routeList=e.data.list
            //             }
            //         })

            //     });

            // },
 
          
           
            





        }
    }
</script>


<style lang="scss">
	
	.hidden{display: none;}
    .fjzxName{color: #f2ff4a;}
    .mdBoxTip{border:1px solid rgba(69,233,255,1);box-shadow:  0 0 30px rgba(69,233,255,0.3) inset;background: rgba(5,83,101,0.4);border-radius: 7px;;width:180px;font-size:13px;text-align:center;font-weight:bold;padding:5px;color:#54ffe1;}
   .mdPhone{font-weight: normal;font-size: 10px;}
    .amap-marker-label {
        background: none !important;
        border: none;
    }
    .mdlogo{border-radius: 50%;}

    .pointer {
        cursor: pointer;
    }

    .custBoyModal {
        background: none;
        width: 384px;

        .modalContent {
            width: 384px;
            height: 244px;
            line-height: 1.5;
            padding: 50px 45px;
            box-sizing: border-box;
            margin: 0 auto;
            text-align: center;
            color: #FFFFFF;
            background: url('../assets/img/06.png') top left no-repeat;
            background-size: 100% 100%;
            text-align: left;
        }
    }

    .baseBody {
        width: 100%;
        height: 100vh;
        overflow: hidden;
        position: relative;
        font-size: 14px;
        background: #000208;
        position: relative;

        .main-wraper {
            user-select: none;
            width: 1920px;
            height: 1080px;
            margin: 0 auto;
            background: #02081a url('../assets/images/sytBg2.png') center no-repeat;
            background-size: cover;
            box-sizing: border-box;
        }

    }

    .dateWeek {
        position: absolute;
        top: 0;
        left: 0;
        width: 200px;
        height: 50px;
        color: #ffffff;
        z-index: 200;
    }

    .fullBox {
        position: absolute;
        top: 0;
        right: 0;
        width: 200px;
        height: 50px;
        color: #ffffff;
        z-index: 999;
    }

    .nyBaseHeadTop {
        width: 100%;
        height: 80px;
        background: url('../assets/images/titleBg.png') top center no-repeat;
        background-size: auto 80px
    }

    .base-headTit {
        font-size: 30px;
        font-weight: bold;
        box-sizing: border-box;
        padding-top: 24px;
    }

    .baseTitleLeft {
        width: 644px;
        height: 55px;
        background: url('../assets/images/titleLeft.png') top right no-repeat;
        background-size: auto 55px
    }

    .baseTitleRight {
        width: 644px;
        height: 55px;
        background: url('../assets/images/titleRight.png') top left no-repeat;
        background-size: auto 55px
    }

    .baseBody .baseTitleContent {
        width: 100%;
        height: 100px;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        z-index: 200;
    }

    .baseBody .baseTitleContent .baseTitleMid {
        width: 659px;
        height: 100px;
        margin: 0 auto;
        background: url('../assets/images/headtitileBg3.png') top left no-repeat;
        background-size: 100% 100px
    }

    .baseBody .baseTitleContent .baseTitleMid .top {
        width: 659px;
        height: 100px;
        margin: 0 auto;
        background: url('../assets/images/headtitileBg2.png') top center no-repeat;
        background-size: 100% 100px
    }

    .baseBody .baseTitleContent .baseTitleMid .topLine {
        width: 659px;
        height: 100px;
        margin: 0 auto;
        background: url('../assets/images/titleBg4.png') top left no-repeat;
        background-size: auto 100px
    }

    .baseBody .baseTitleContent .baseTitleMid .title {
        width: 100%;
        height: 70px;
        margin: 0 auto;
        font-size: 34px;
        font-weight: bold;
        line-height: 70px;
        background: url('../assets/images/headtitileBg1.png') top center no-repeat;
		background-position: center;
		background-size: 100% auto;
        // background-size: auto 70px
    }

    .dataItem {
        width: 180px;
        height: 95px;
        line-height: 1;
        margin: 0 auto;
        text-align: center;
        color: #FFFFFF;
        background: url('../assets/img/04.png') top left no-repeat;
        background-size: 100% 100%;
        padding-top: 18px;
        box-sizing: border-box;

        .title {
            font-size: 18px;
            font-weight: bold;
        }

        .num {
            font-size: 41px;
            font-weight: bold;
            margin-top: 10px;
            color: #43eb93;

            &.yc {
                color: #ff8a00;
            }

            &.blue {
                color: #00d8ff;
            }

            &.purper {
                color: #c62bff;
            }

            &.red {
                color: #ff94a3;
            }

            s &.yellow {
                color: #fdc671;
            }
        }
    }

    .bgImg {
        width: 1920px;
        height: 1080px;
        line-height: 1;
        margin: 0 auto;
        text-align: center;
        color: #FFFFFF;
        background: url('../assets/img/bg.png') top left no-repeat;
        background-size: 100% 100%;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 120;
        pointer-events: none;
    }

    .custBodybg {
        width: 1920px;
        height: 1080px;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 100;
        pointer-events: none;
        background: -webkit-radial-gradient(rgba(0, 12, 38, 0) 30%, #000c26 100%, #000c26 100%);
        /* Safari 5.1 - 6.0 */
        background: -o-radial-gradient(rgba(0, 12, 38, 0) 30%, #000c26 100%, #000c26 100%);
        /* Opera 11.6 - 12.0 */
        background: -moz-radial-gradient(rgba(0, 12, 38, 0) 30%, #000c26 100%, #000c26 100%);
        /* Firefox 3.6 - 15 */
        background: radial-gradient(rgba(0, 12, 38, 0) 30%, #000c26 100%, #000c26 100%);
        /* 标准的语法 */
    }
    .mdBoxTip{
        
    }
</style>